import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/Core/services/user.service';

@Component({
  selector: 'app-location-display',
  templateUrl: './location-display.component.html',
  styleUrls: ['./location-display.component.css']
})
export class LocationDisplayComponent implements   OnInit{
  userID: string = '';
  locations: any;
  locationDisplayToggle: boolean = true;
  
  constructor(private route: ActivatedRoute, private userService: UserService) {}
  
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userID = params.get('id') || '';
      this.fetchLocation();
    });
  }

  fetchLocation(): void { 
    this.userService.getLocations(this.userID).subscribe((data) => {
      this.locations = data;
    });
  }
  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }

  roleMappings: { [key: string]: { display: string; tooltip: string } } = {
    'owner': { display: 'Owner', tooltip: 'Chief Member' },
    'activator': { display: 'Activator', tooltip: 'Deputy Member' },
    'viewer': { display: 'Viewer', tooltip: 'Crew Member' }
  };
  
  getDisplayRole(role: string): string {
    return this.roleMappings[role]?.display || this.capitalizeFirstLetter(role);
  }
  
  getRoleTooltip(role: string): string {
    return this.roleMappings[role]?.tooltip || this.capitalizeFirstLetter(role);
  }
}